import "react-phone-number-input/style.css";
import React, { Component } from "react";
import PhoneInput from "react-phone-number-input";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { Loader } from "../../../components/loader";
import { MultiSelect } from "react-multi-select-component";
import {
  addNotification,
  getNotifications,
  testNotification,
  getCustomersForGrid,
  getNotificationMessages,
  sendMessagesToGrid,
} from "../../../actions/notificationManager";

let formData = {};
let testFormData = {};
const $ = window.$;
const customerCountOptions = [
  { id: "1", value: "10" },
  { id: "2", value: "20" },
  { id: "3", value: "50" },
  { id: "4", value: "100" },
  { id: "5", value: "All" },
];
const initialState = {
  message: "",
  test_phone_number: "",
  customerCount: 10,
  placeholder: "{first_name}",
  isTestClick: false,
  isLoading: false,
  isTestLoading: false,
  isFormNotValid: false,
  isTestFormNotValid: false,
  copied: false,
  isGridSelected: false,
  customers: [],
  selectedCustomers: [],
  isUseMessageTemplateSelected: false,
  notificationMessages: [],
  selectedMessageId: null,
};
class SendNotification extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.newNotification !== nextProps.newNotification) {
      this.closeModal();
      this.props.getNotifications();
    }

    if (this.props.newNotificationError !== nextProps.newNotificationError) {
      if (nextProps.newNotificationError && nextProps.newNotificationError.details) {
        NotificationManager.error(nextProps.newNotificationError.details.message);
        this.setState({ isLoading: false });
      }
    }

    if (this.props.testMessage !== nextProps.testMessage) {
      this.setState({ isTestLoading: false });
      NotificationManager.success("Test notification sent successfully");
    }

    if (this.props.testMessageError !== nextProps.testMessageError) {
      this.setState({ isTestLoading: false });
      if (nextProps.testMessageError && nextProps.testMessageError.details) {
        NotificationManager.error(nextProps.testMessageError.details.message);
      }
    }

    if (this.props.customers !== nextProps.customers) {
      if (nextProps.customers.length > 0) {
        let formatCustomers = [];
        let customer;

        for (let object of nextProps.customers) {
          customer = {
            label: `${object.firstname} ${object.lastname} - ${object.pet_id}`,
            value: `${object.customer_id}`,
          };
          formatCustomers.push(customer);
        }

        this.setState({ customers: formatCustomers });
      }
    }

    if (this.props.customersError !== nextProps.customersError) {
      if (nextProps.customersError && nextProps.customersError.details) {
        NotificationManager.error(nextProps.customersError.details.message);
      }
    }

    if (this.props.messages !== nextProps.messages) {
      this.setState({ notificationMessages: nextProps.messages });
    }

    if (this.props.messagesError !== nextProps.messagesError) {
      if (nextProps.messagesError && nextProps.messagesError.details) {
        NotificationManager.error(nextProps.messagesError.details.message);
      }
    }

    if (this.props.messageToGrid !== nextProps.messageToGrid) {
      this.closeModal();
      this.props.getNotifications();
    }

    if (this.props.messageToGridError !== nextProps.messageToGridError) {
      if (nextProps.messageToGridError && nextProps.messageToGridError.details) {
        NotificationManager.error(nextProps.messageToGridError.details.message);
        this.setState({ isLoading: false });
      }
    }
  };

  closeModal = () => {
    this.setState(initialState);
    $("#send-notification-modal").modal("toggle");
    if ($("#placeholder").length > 0) {
      $("#placeholder")[0].selectedIndex = 0;
    }
  };

  onChange = (e) => {
    if (e.target.name === "message" && e.target.value !== null) {
      this.setState({ isFormNotValid: false });
    }

    if (e.target.name === "template") {
      if (e.target.value !== "default") {
        let index = e.target.value;
        this.setState({
          message: this.state.notificationMessages[index].message,
          selectedMessageId: this.state.notificationMessages[index].id,
        });
      } else {
        this.setState({ message: "", selectedMessageId: null });
      }
    }

    this.setState({ [e.target.name]: e.target.value });
  };

  onGridSelectChange = (e) => {
    this.setState({
      isGridSelected: e.target.checked,
    });

    if (e.target.checked) {
      this.props.getCustomersForGrid();
    } else {
      this.setState({ selectedCustomers: [] });
    }
  };

  onUseMessageTemplateChange = (e) => {
    this.setState({
      isUseMessageTemplateSelected: e.target.checked,
    });

    if (e.target.checked) {
      this.props.getNotificationMessages();
    } else {
      this.setState({
        message: "",
        selectedMessageId: null,
      });
    }
  };

  onCustomerSelectChange = (customer) => {
    this.setState({
      selectedCustomers: customer,
    });
  };

  onCopy = (e) => {
    this.setState({ copied: true });
  };

  addPlaceholderToMousePointer = (e) => {
    e.preventDefault();
    let textField = $("#message-area").length > 0 && $("#message-area")[0];
    let selectedPlaceholder = this.state.placeholder;

    if (document.selection) {
      textField.focus();
      let sel = document.selection.createRange();
      sel.text = selectedPlaceholder;
    } else if (textField.selectionStart || textField.selectionStart == "0") {
      textField.focus();
      let startPosition = textField.selectionStart;
      let endPosition = textField.selectionEnd;

      textField.value =
        textField.value.substring(0, startPosition) +
        " " +
        selectedPlaceholder +
        textField.value.substring(endPosition, textField.value.length);
    } else {
      textField.value = selectedPlaceholder;
    }

    this.setState({ message: textField.value });
  };

  validateForm = () => {
    const { message, isGridSelected, selectedCustomers } = this.state;
    const data = {
      message: message && message.trim().length > 0 ? message : null,
      message_length: message && message.trim().length <= 200 ? message : null,
      customer_grid: isGridSelected
        ? selectedCustomers.length > 0
          ? selectedCustomers
          : null
        : selectedCustomers,
    };

    formData = Object.assign({}, data);
    return true;
  };

  validateTestForm = () => {
    const { test_phone_number, message } = this.state;
    const data = {
      test_message: message && message.trim().length > 0 ? message : null,
      phone_number:
        test_phone_number && test_phone_number.trim().length > 0 ? test_phone_number : null,
      test_message_length: message && message.trim().length <= 200 ? message : null,
    };

    testFormData = Object.assign({}, data);
    return true;
  };

  setTestPhone = (value) => {
    this.setState({ test_phone_number: value });
  };

  sendTestMessage = (e) => {
    e.preventDefault();
    this.setState({ isTestClick: true });
    const isTestFormValid = this.validateTestForm();

    if (isTestFormValid) {
      let data = Object.values(testFormData).map((key) => {
        return key !== null;
      });

      if (!data.includes(false)) {
        const { message, test_phone_number } = this.state;
        const data = {
          message: message,
          phone_number: test_phone_number,
        };

        this.props.testNotification(data);
        this.setState({ isTestLoading: true });
      } else {
        this.setState({ isTestFormNotValid: true });
        NotificationManager.warning("Please check the input details again");
      }
    }
  };

  onSubmit = (e) => {
    e.preventDefault();

    const isFormValid = this.validateForm();

    if (isFormValid) {
      let data = Object.values(formData).map((key) => {
        return key !== null;
      });

      if (!data.includes(false)) {
        const { isGridSelected, message, selectedMessageId, customerCount, selectedCustomers } =
          this.state;

        if (isGridSelected) {
          let customerIds = [];
          for (let customer of selectedCustomers) {
            customerIds.push(parseInt(customer.value));
          }
          const data = {
            message: message,
            customerIds: customerIds,
            messageId: selectedMessageId,
          };         
          this.props.sendMessagesToGrid(data);
          this.setState({ isLoading: true });
        } else {
          const data = {
            message: message,
            messageId: selectedMessageId,
            noOfCustomers:
              this.state.customerCount === "All" ? "All" : parseInt(this.state.customerCount),
          };      
          this.props.addNotification(data);
          this.setState({ isLoading: true });
        }
      } else {
        this.setState({ isFormNotValid: true });
        NotificationManager.warning("Please check the input details again");
      }
    }
  };

  render() {
    const {
      message,
      customerCount,
      isLoading,
      isTestLoading,
      isFormNotValid,
      isTestFormNotValid,
      test_phone_number,
      isTestClick,
      placeholder,
      isGridSelected,
      customers,
      selectedCustomers,
      notificationMessages,
      isUseMessageTemplateSelected,
    } = this.state;
    $("#message-area").attr(
      "placeholder",
      "Hi {first name} {last name}," + "\n\n" + "Enter your message"
    );

    return (
      <div
        className="modal fade mt-5 message"
        id="send-notification-modal"
        tabIndex="-1"
        role="dialog"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-md" role="document">
          <div className="modal-content">
            {/* Start: Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Send Notification
              </h5>
              <button type="button" className="close" aria-label="Close" onClick={this.closeModal}>
                <span aria-hidden="true">×</span>
              </button>
            </div>
            {/* End: Modal Header */}

            {/* Start: Modal Body */}
            <div className="modal-body">
              <div className="mt-1">
                <div className="mt-1">
                  <label className="mb-3">
                    <input
                      name="isGridSelected"
                      type="checkbox"
                      checked={isUseMessageTemplateSelected}
                      onChange={this.onUseMessageTemplateChange}
                    />
                    <span className="ml-1">
                      <strong>Use existing message template</strong>
                    </span>
                  </label>
                  {isUseMessageTemplateSelected && (
                    <select className="form-control mb-3" name="template" onChange={this.onChange}>
                      <option value="default">Select message template</option>
                      {notificationMessages.length > 0 &&
                        notificationMessages.map((template, index) => (
                          <option key={index} value={index}>
                            {template.message.trim().length >= 60
                              ? `${template.message.slice(0, 60)}.....`
                              : `${template.message}`}
                          </option>
                        ))}
                      {/* ${address.slice(0, chars)}...${address.slice(-chars)} */}
                    </select>
                  )}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Placeholders:</label>
                      <select
                        className="form-control"
                        name="placeholder"
                        onChange={this.onChange}
                        value={placeholder}
                      >
                        <option value="{first_name}">First name</option>
                        <option value="{last_name}">Last name</option>
                        <option value="{social_link}">Social Media Promo Link</option>
                      </select>
                    </div>
                    <div className="col-md-6 placeholder">
                      <div className="input-group">
                        <input type="text" className="form-control" disabled value={placeholder} />
                        <div className="input-group-append">
                          <button
                            className="btn btn-info"
                            onClick={this.addPlaceholderToMousePointer}
                          >
                            <i className="fa fa-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <label className="form-label">
                    Message<span className="required-asterisk">*</span> :
                  </label>
                  <textarea
                    id="message-area"
                    onChange={this.onChange}
                    value={message}
                    className="form-control mt-0"
                    name="message"
                    rows="7"
                  />
                  <div className="d-flex">
                    {!isTestClick ? (
                      <span>
                        {isFormNotValid && formData.message === null ? (
                          <span className="validate-warning">Message is required</span>
                        ) : null}
                        {isFormNotValid &&
                        formData.message !== null &&
                        formData.message_length === null ? (
                          <span className="validate-warning">Maximum character count exceed</span>
                        ) : null}
                      </span>
                    ) : (
                      <span>
                        {isTestFormNotValid && testFormData.test_message === null ? (
                          <span className="validate-warning">Message is required</span>
                        ) : null}
                        {isTestFormNotValid &&
                        testFormData.test_message !== null &&
                        testFormData.test_message_length === null ? (
                          <span className="validate-warning">Maximum character count exceed</span>
                        ) : null}
                      </span>
                    )}
                    <div className="word-count ml-auto p-0 mb-3">{message.length}/200</div>
                  </div>

                  <label className="mb-3">
                    <input
                      name="isGridSelected"
                      type="checkbox"
                      checked={isGridSelected}
                      onChange={this.onGridSelectChange}
                    />
                    <span className="ml-1">Send messages to selected customers</span>
                  </label>
                  {isGridSelected && (
                    <div>
                      <MultiSelect
                        options={customers}
                        onChange={this.onCustomerSelectChange}
                        value={selectedCustomers}
                      />
                      {isFormNotValid && formData.customer_grid === null ? (
                        <span className="validate-warning">Select one or more customers</span>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
              {!isGridSelected && (
                <div className="form-group m-form__group row">
                  <label className="col-xl-6 col-lg-6 col-form-label mt-3">
                    Number of Customers
                    <span className="required-asterisk">*</span> :
                  </label>
                  <span className="col-xl-6 col-lg-6">
                    <select
                      type="text"
                      name="customerCount"
                      className="form-control m-input mt-3"
                      value={customerCount}
                      onChange={this.onChange}
                    >
                      {customerCountOptions.map((option) => (
                        <option key={option.id} value={option.value}>
                          {option.value}
                        </option>
                      ))}
                    </select>
                  </span>
                </div>
              )}
              <div className="test">
                <div className="mt-4 border border-secondary rounded p-3">
                  <h5 className="test-message">Test Message</h5>
                  <div className="row no-gutters">
                    <div className="col-md-10 col-9">
                      <PhoneInput
                        defaultCountry="US"
                        className="ml-1 test-phone"
                        placeholder="Enter the Phone Number"
                        value={test_phone_number}
                        onChange={this.setTestPhone}
                      />
                      {isTestFormNotValid && testFormData.phone_number === null ? (
                        <span className="validate-warning">Phone number is required</span>
                      ) : null}
                    </div>
                    <div className="col-md-2 col-3">
                      {isTestLoading ? (
                        <Loader size={24} />
                      ) : (
                        <button
                          className="btn btn-outline-info btn-sm m-btn--pill mx-2 test-btn"
                          onClick={this.sendTestMessage}
                        >
                          Test
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End: Modal Body */}

            {/* Start: Modal Footer */}
            <div className="modal-footer">
              {isLoading ? (
                <Loader size={50} />
              ) : (
                <div>
                  <button
                    type="button"
                    className="btn btn-secondary m-btn--pill mx-2"
                    onClick={this.closeModal}
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary m-btn--pill"
                    onClick={this.onSubmit}
                  >
                    <span>
                      <i className="fas fa-paper-plane mr-1"></i>Send
                    </span>
                  </button>
                </div>
              )}
            </div>
            {/* End: Modal Footer */}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  newNotification: state.notificationManagerReducer.addNotification,
  newNotificationError: state.notificationManagerReducer.addNotificationError,
  testMessage: state.notificationManagerReducer.testNotification,
  testMessageError: state.notificationManagerReducer.testNotificationError,
  customers: state.notificationManagerReducer.customersForGrid,
  customersError: state.notificationManagerReducer.customersForGridError,
  messages: state.notificationManagerReducer.notificationMessages,
  messagesError: state.notificationManagerReducer.notificationMessagesError,
  messageToGrid: state.notificationManagerReducer.messageToGrid,
  messageToGridError: state.notificationManagerReducer.messageToGridError,
});

const mapDispatchToProps = (dispatch) => ({
  addNotification: (data) => {
    dispatch(addNotification(data));
  },
  getNotifications: () => {
    dispatch(getNotifications());
  },
  testNotification: (data) => {
    dispatch(testNotification(data));
  },
  getCustomersForGrid: () => {
    dispatch(getCustomersForGrid());
  },
  getNotificationMessages: () => {
    dispatch(getNotificationMessages());
  },
  sendMessagesToGrid: (data) => {
    dispatch(sendMessagesToGrid(data));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SendNotification));
